/**
 * App version shown in the UI: `v0.1.0 · a1b2c3d` — the human-readable semver from package.json plus
 * the short build SHA for support/traceability. Both are injected by `vite.config.ts` at build time.
 */
const semver = import.meta.env.VITE_APP_SEMVER ?? "0.0.0"
const build = import.meta.env.VITE_APP_VERSION ?? ""

export const APP_VERSION_LABEL = (() => {
  const base = `v${semver}`
  const shortBuild = build && build !== "unknown" && build !== semver ? ` · ${build.slice(0, 7)}` : ""
  return `${base}${shortBuild}`
})()
